import React, { useEffect } from "react";
import { CircularProgress, Box, Typography } from "@material-ui/core";
import Layout from "../components/Layout";
import ProductsList from "../Products/productsList";
import BasicPagination from "../components/Pagination";
import background from "../../../assets/images/background.png";
import SearchBar from "../components/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { endSession, getVMProducts } from "../../../redux/actions";//fetching the data from this call
import useWindowUnloadEffect from "../components/hooks/useWindowUnloadEffect";

const Products = () => {
  const sessionData = useSelector((state) => state.touchless.sessionData);
  const productsList = useSelector((state) => state.touchless.products);
  const themeData = useSelector((state) => state.touchless.theme);
  const isLoading = useSelector((state) => state.touchless.isLoading);
  const {
    name,
    background_img_url ,
    background_opacity 
  } = themeData || {};
  const shopLimit = useSelector((state) => state.touchless.shopLimit);
  const cssOpacity = background_opacity && !isNaN(background_opacity) ?
                      background_opacity>0?
                            1- background_opacity / 100 :1//here if zero is sent it will adapt
                    :name!=="default"?  
                            background_img_url? 0 : 1 : 0;

  var final_background_img_url=background_img_url
  if(background_img_url==""){

    final_background_img_url=background;
  }
  

  const dispatch = useDispatch();

  const unLoadHandler = (e) => {
    const confirmationMessage =
      "It looks like you have been editing something. If you leave before saving, your changes will be lost.";

    if ((e || window.event).returnValue) {
      (e || window.event).returnValue = confirmationMessage;
    }

    return confirmationMessage;
  };

  useWindowUnloadEffect(unLoadHandler, true);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const serial_no = urlParams.get("serial_no");
    // if (sessionData) {
    dispatch(endSession());

    dispatch(getVMProducts(serial_no));
    //   dispatch(continueSession());
    // } else {
    //   window.location.href = "/webstore";
    // }

    return () => {
      // dispatch(endSession());
    };
  }, [dispatch]);

  // useEffect(() => {
  //   if (timer <= 0) {
  //     dispatch(endSession());
  //   }
  // }, [timer, dispatch]);

  return (
    <Layout>
      <div
        style={{
          position:"relative",
          backgroundImage: name =="default"?`url(${background})`:`url(${final_background_img_url})`,
          backgroundSize: "cover",  
          overflowX: "hidden",
          overflowY: "auto",
          flex: "1",
          backgroundPosition: "center",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          
        }}
      >
      <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity:  name =="default"? 0.00:cssOpacity,
        backgroundColor: "white",
      }}
    ></div>

        <SearchBar />
        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          justifyContent="space-between"
        >
          {!isLoading && productsList.length === 0 && (
            <Box
              mt={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5">
                <b>No Products Found</b>
              </Typography>
            </Box>
          )}
          {isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : (
            <ProductsList productsList={productsList} />
          )}
          <BasicPagination />
        </Box>
      </div>

    </Layout>
  );
};

export default Products;
